const tab_sections = {
    identity: 'Identidad',
    integrations: 'Conexiones',
    login_security: 'Acceso y seguridad',
    permissions: 'Permisos',
    automation: 'Automatización',
    platform: 'Plataforma',
    overview: 'Visión general',
    authentication: 'Autenticación',
    authorization: 'Autorización',
    users: 'Usuarios',
    developer: 'Desarrollador',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
